import React, { useEffect, useState } from 'react';
import ScrollContainer from 'react-indiana-drag-scroll';
import { toast } from 'react-toastify';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as moment from "moment";
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';

import Header from "../../components/Header";

import { createUser, getUser } from "../../auth/Auth";
import { loadUsers } from "../../common/Common";
import { postRequest, uploadFile } from "../../routes/Routes";

import avatar from "../../assets/images/avatar.png";
import back from "../../assets/images/back.svg";

import '../../assets/css/ManageAdmins.css';

function ManageClient({ passedClient, backButton }) {
    const [user, setUser] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [users, setUsers] = useState([]);
    const [clientUsers, setClientUsers] = useState(passedClient ? passedClient.users : []);
    const [filteredClientUsers, setFilteredClientUsers] = useState(passedClient ? passedClient.users : []);
    const [loading, setLoading] = useState(false);
    const [sendLoading, setSendLoading] = useState(false);
    const [error, setError] = useState({});
    const [success, setSuccess] = useState({});
    const [isMobile, setIsMobile] = useState(false);
    const [addUser, setAddUser] = useState(false);
    const [editClient, setEditClient] = useState(true);
    const [selectedClient, setSelectedClient] = useState(passedClient);
    const [profileImage, setProfileImage] = useState(null);
    const [clientProfileImage, setClientProfileImage] = useState(null);
    const uploadProfileImageInput = React.createRef();
    const uploadClientProfileImageInput = React.createRef();

    useEffect(() => {
        getUser().then((data) => {
            setUser(data);
            let values = {
                context: {
                    action: 'List Users'
                },
                endpoint: '/api/user/list',
                token: data.token
            };
            loadUsers(values).then(data => {
                setUsers(data);
            }).catch(() => null);
        }).catch(() => null);
    }, []);

    useEffect(() => {
        const updateMedia = () => setIsMobile(window.innerWidth < 768);
        updateMedia();
        window.addEventListener('resize', updateMedia);
        return () => window.removeEventListener('resize', updateMedia);
    }, []);

    const filterUsers = (text) => {
        let filteredUsers;
        if (text === '') {
            filteredUsers = clientUsers;
        } else {
            text = text.toLowerCase();
            filteredUsers = clientUsers.filter((user) => `${user.firstName}`.toLowerCase().includes(text) || `${user.lastName}`.toLowerCase().includes(text) || `${user.email}`.toLowerCase().includes(text));
        }
        setFilteredClientUsers(filteredUsers);
    };

    const userBody = (users) => {
        let body = [];

        if (users.length === 0) {
            body.push(
                <div key="noUsers" className="no-users">No Users Available</div>
            );
        }

        users.forEach((user, index) => {
            body.push(
                <div key={index}
                    onClick={() => {
                        setSelectedUser(user);
                        setAddUser(false);
                        setEditClient(false);
                        setError(values => ({ ...values, error: false, message: null }));
                        setSuccess(values => ({ ...values, success: false, message: null }));
                    }}
                    className={selectedUser && selectedUser.email === user.email ? 'active-user' : ''}>
                    {user.firstName}
                    <hr className="active-hr" />
                </div>
            );
        });
        return body;
    }

    const renderRemoveButton = (users) => {
        const isLastUser = users.length === 1;

        return isLastUser ? (
            <div title="Last user of the client cannot be removed." className='tooltip-wrapper' style={{ marginRight: "5%" }}>
                <button
                    type="button"
                    className="red-button"
                    data-bs-toggle="modal"
                    data-bs-target="#deleteUserModal"
                    disabled
                    style={{
                        opacity: 0.5,
                        marginRight: "33.5px",
                        height: "100%",
                        cursor: 'not-allowed'
                    }}
                >
                    Remove
                </button>
            </div>
        ) : (
            <button
                type="button"
                className="red-button"
                data-bs-toggle="modal"
                data-bs-target="#deleteUserModal"
                style={{
                    cursor: 'pointer'
                }}
            >
                Remove
            </button>
        );
    };




    const handleChange = (event, key) => {
        if (key === 'email') {
            if (event.__isNew__) {
                setAddUser(true);
                setSelectedUser({
                    email: event.email || event.label || '',
                    __isNew__: true
                });
            } else {
                const existing = users.find(u => u.email === event.email || u.email === event.label);
                if (existing) {
                    setAddUser(false);
                    setSelectedUser(existing);

                } else {
                    setAddUser(true);
                    setSelectedUser({
                        email: event.email || event.label || '',
                        __isNew__: true
                    });
                }
            }
        } else {
            setSelectedUser(prev => ({
                ...(prev || {}),
                [key]: event.target.value
            }));
        }
    };

    const handleClientChange = (event, key) => {
        const isDateField = key === 'financialDate' || key === 'foundedDate' || key === 'deadlineDate';

        const value = key === 'primaryUser'
            ? event
            : isDateField
                ? formatDate(event)
                : event.target.value;

        setSelectedClient(prevState => ({
            ...prevState,
            [key]: value,
        }));
    };

    const formatDate = (input) => {

        if (input instanceof Date && !isNaN(input)) {
            return moment(input).format('YYYY-MM-DD');
        }

        const m = moment(input, moment.ISO_8601, true);

        if (!m.isValid()) {
            const fallback = moment(input, [
                "DD/MM/YYYY",
                "MM-DD-YYYY",
                "YYYY-MM-DD",
                "DD-MM-YYYY",
                "MM/DD/YYYY",
            ],
                true
            );
            return fallback.isValid() ? fallback.format('YYYY-MM-DD') : null;
        }

        return m.format('YYYY-MM-DD');
    };

    const clientFormSubmit = (event) => {
        event.preventDefault();
        setLoading(true);

        if (!selectedClient?.foundedDate) {
            setError({
                error: true,
                errorMessage: "Founded Date is required."
            });
            setLoading(false);
            return;
        }
        if (!selectedClient?.financialDate) {
            setError({
                error: true,
                errorMessage: "Financial Date is required."
            });
            setLoading(false);
            return;
        }
        if (!selectedClient?.deadlineDate) {
            setError({
                error: true,
                errorMessage: "Deadline Date is required."
            });
            setLoading(false);
            return;
        }

        const values = {
            dto: {
                email: selectedClient?.email || '',
                name: selectedClient?.name || '',
                companyNumber: selectedClient?.companyNumber || '',
                companyUTR: selectedClient?.companyUTR || '',
                businessType: selectedClient?.businessType || '',
                authCode: selectedClient?.authCode || '',
                vatNumber: selectedClient?.vatNumber || '',
                addressLineOne: selectedClient?.addressLineOne || '',
                addressLineTwo: selectedClient?.addressLineTwo || '',
                city: selectedClient?.city || '',
                postcode: selectedClient?.postcode || '',
                foundedDate: selectedClient?.foundedDate || null,
                financialDate: selectedClient?.financialDate || null,
                deadlineDate: selectedClient?.deadlineDate || null,
                primaryUser: selectedClient?.primaryUser || null,
                users: selectedClient?.id ? selectedClient.users : [],
                status: selectedClient?.id ? selectedClient.status : null,
                id: selectedClient?.id || null
            },

            context: { action: 'Update Client' },
            endpoint: '/api/client/update',
            token: user.token
        };

        // Call your API function here (e.g., postRequest(values))
        postRequest(values).then(response => {
            if (response.status === 200) {
                setSelectedClient({ ...response.data });
                setError(values => ({ ...values, error: false, message: null }));
                setSuccess(values => ({ ...values, success: true, message: 'Successfully updated client' }));
            } else {
                setError(values => ({
                    ...values,
                    error: true,
                    errorMessage: response.data.message || "An error occurred!"
                }));
            }
            setLoading(false);
        });
    };

    const formSubmit = (event) => {
        setLoading(true);
        event.preventDefault();

        let values = {
            dto: {
                email: selectedUser?.email || '',
                firstName: selectedUser?.firstName || '',
                lastName: selectedUser?.lastName || '',
                addressLineOne: selectedUser?.addressLineOne || '',
                addressLineTwo: selectedUser?.addressLineTwo || '',
                city: selectedUser?.city || '',
                postcode: selectedUser?.postcode || '',
                phone: selectedUser?.phone || '',
                financialDate: selectedClient?.financialDate || '',
                foundedDate: selectedClient?.foundedDate || '',
                deadlineDate: selectedClient?.deadlineDate || '',
                primaryUser: selectedClient?.primaryUser || null,
                users: selectedClient?.id ? selectedClient.users : [],
                status: selectedClient?.id ? selectedClient.status : null,
                id: selectedClient?.id || null
            },
            context: {
                action: addUser ? 'Create User' : 'Update User'
            },
            endpoint: addUser ? '/api/user/create-user' : '/api/user/update',
            token: user.token
        };

        postRequest(values).then(response => {
            if (response.status === 200) {
                const updatedUserData = { ...response.data };

                setUsers(prevUsers => prevUsers.map(user => user.email === selectedUser.email ? updatedUserData : user));
                setClientUsers(prevClientUsers => prevClientUsers.map(user => user.email === selectedUser.email ? updatedUserData : user));
                setFilteredClientUsers(prevFilteredClientUsers => prevFilteredClientUsers.map(user => user.email === selectedUser.email ? updatedUserData : user));
                setSelectedUser(updatedUserData);

                const updatedUsers = [
                    ...selectedClient.users.filter(u => u.email !== updatedUserData.email),
                    updatedUserData
                ];

                let clientValues = {
                    dto: {
                        ...selectedClient,
                        users: updatedUsers,
                        id: selectedClient.id,
                    },
                    context: { action: 'Update Client' },
                    endpoint: '/api/client/update',
                    token: user.token,
                };

                postRequest(clientValues).then(clientResponse => {
                    if (clientResponse.status === 200) {
                        setSelectedClient({ ...clientResponse.data });
                        setClientUsers(updatedUsers);
                        setFilteredClientUsers(updatedUsers);
                    } else {
                        setError(values => ({
                            ...values,
                            error: true,
                            errorMessage: clientResponse.data.message || "An error occurred!"
                        }));
                    }
                });

                setAddUser(false);
                setError(values => ({ ...values, error: false, message: null }));
                setSuccess(values => ({ ...values, success: true, message: 'Successfully updated user' }));
            } else {
                setError(values => ({
                    ...values,
                    error: true,
                    errorMessage: response.data.message || "An error occurred!"
                }));
            }
            setLoading(false);
        });
    };

    const removeUser = () => {
        {
            let values = {
                dto: {
                    users: selectedClient.users.filter(function (user) {
                        return user.email !== selectedUser.email;
                    }),
                    id: selectedClient.id,
                },
                context: {
                    action: 'Update Client'
                },
                endpoint: '/api/client/update',
                token: user.token
            };
            postRequest(values).then(response => {
                if (response.status === 200) {
                    setClientUsers(values =>
                        values.filter(function (user) {
                            return user.email !== selectedUser.email;
                        }),
                    );
                    setFilteredClientUsers(values =>
                        values.filter(function (user) {
                            return user.email !== selectedUser.email;
                        }),
                    );
                    setSelectedClient({ ...response.data });
                    setSelectedUser(null);
                    toast.success('Successfully removed User', {
                        position: "bottom-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                } else {
                    toast.error("An error occurred!", {
                        position: "bottom-center",
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            });
        }
    }

    const addUserButton = () => {
        setAddUser(true);
        setEditClient(false)
        setSelectedUser(null);
        setError(values => ({ ...values, error: false, message: null }));
        setSuccess(values => ({ ...values, success: false, message: null }));
    }

    const sendInvitation = () => {
        setSendLoading(true);

        const values = {
            dto: {
                user: { email: selectedUser.email },
                client: { id: selectedClient.id }
            },
            context: {
                action: 'Send Client Invitation'
            },
            endpoint: '/api/user-client-invitation/send',
            token: user.token
        };

        postRequest(values).then(response => {
            if (response.status === 200) {
                toast.success(response.data.message, {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });

                const newInvite = {
                    clientId: selectedClient.id,
                    isUsed: true
                };

                // Merge or add this invite into existing ones
                const updatedInvitations = (selectedUser.userClientInvitations || []).filter(
                    invite => invite?.clientId !== selectedClient.id
                );

                updatedInvitations.push(newInvite);

                setSelectedUser(prev => ({
                    ...prev,
                    userClientInvitations: updatedInvitations
                }));

            } else {
                toast.error("An error occurred!", {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }).finally(() => setSendLoading(false));
    };




    const uploadProfileImage = (event) => {
        event.preventDefault();
        const data = new FormData();
        data.append('file', uploadProfileImageInput.current.files[0]);
        uploadFile(data, '/api/user/upload?user=' + selectedUser.email, { token: user.token }).then(response => {
            if (response.status !== 200) {
                toast.error("An error occurred!", {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
            toast.success("Successfully uploaded profile image", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setUsers(values =>
                values.map(user => {
                    if (user.email === selectedUser.email) {
                        return { ...response.data };
                    }
                    return user;
                }),
            );
            setClientUsers(values =>
                values.map(user => {
                    if (user.email === selectedUser.email) {
                        return { ...response.data };
                    }
                    return user;
                }),
            );
            setFilteredClientUsers(values =>
                values.map(user => {
                    if (user.email === selectedUser.email) {
                        return { ...response.data };
                    }
                    return user;
                }),
            );
            setSelectedUser({ ...response.data });
            setProfileImage(null);
            if (selectedUser.email === user.email) {
                response.data = { ...response.data, token: user.token };
                createUser(response.data).then(() => {
                    window.location.href = '/';
                });
            }
        });
    }

    const uploadClientImage = (event) => {
        event.preventDefault();
        setLoading(true);

        const data = new FormData();
        data.append('file', uploadClientProfileImageInput.current.files[0]);
        uploadFile(data, '/api/client/upload?client=' + selectedClient.id, { token: user.token }).then(response => {
            if (response.status !== 200) {
                toast.error("An error occurred!", {
                    position: "bottom-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
            toast.success("Successfully uploaded client image", {
                position: "bottom-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setSelectedClient({ ...response.data });
            setClientProfileImage(null);
            setLoading(false);
        });
    }

    if (user) {
        return (
            <>
                <Header component="Manage Client" addUserButton={addUserButton} selectedClient={selectedClient} />
                <div className="grey-background full-height">
                    <button className="back-button borderless-button" onClick={() => backButton()}>
                        <img src={back} alt="Back" />
                    </button>
                    <div className="container">
                        <div className="d-flex name-container client-name-container">
                            <div className={(editClient ? 'active-user' : '') + ' p-2 client-name-container'}
                                style={{ textAlign: "center" }}
                                onClick={() => {
                                    setSelectedUser(null);
                                    setAddUser(false);
                                    setEditClient(true);
                                    setError(values => ({ ...values, error: false, message: null }));
                                    setSuccess(values => ({ ...values, success: false, message: null }));
                                }}>
                                {selectedClient && selectedClient.name ? selectedClient.name : 'Company Name'}
                                <hr className="active-hr" />
                            </div>
                            <div className="p-2 desktop-admin-search">
                                <ScrollContainer>
                                    <div className="name-list-container">
                                        {userBody(filteredClientUsers)}
                                    </div>
                                </ScrollContainer>
                            </div>
                            <div className="p-2 desktop-admin-search">
                                <input type="label" placeholder='Search Admins' className='search-input'
                                    onChange={(event) => filterUsers(event.target.value)} />
                            </div>
                            <div className="p-2 mobile-admin-search">
                                <Select
                                    className="basic-single btn w-100 select user-select"
                                    id="primaryUser" options={clientUsers}
                                    onChange={(event) => {
                                        setSelectedUser(event);
                                        setAddUser(false);
                                        setEditClient(false);
                                        setError(values => ({ ...values, error: false, message: null }));
                                        setSuccess(values => ({ ...values, success: false, message: null }));
                                    }}
                                    defaultValue={selectedUser}
                                    getOptionValue={option => option['email']}
                                    getOptionLabel={option => option['firstName']} />
                            </div>
                        </div>
                        {editClient &&
                            <div className="admin-detail-container">
                                <div className="d-flex admin-image-container">
                                    <div>
                                        {selectedClient && selectedClient.imageUrl ?
                                            <img src={selectedClient.imageUrl} alt={selectedClient.firstName}
                                                className='user-image' />
                                            : <img src={avatar} alt="Avatar" className='user-image' />
                                        }
                                    </div>
                                    <div className="d-flex">
                                        <div className="admin-name">
                                            {selectedClient ? (selectedClient.name ? selectedClient.name : '') : null}
                                            <p>
                                                PNG or JPG no bigger than 1000px wide and tall.
                                            </p>
                                        </div>
                                        <div>
                                            <button className='borderless-button' data-bs-toggle="modal"
                                                data-bs-target="#clientImageModal"
                                                disabled={!(selectedClient && selectedClient.hasOwnProperty('id'))}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="currentColor"
                                                    className="bi bi-upload" viewBox="0 0 16 16">
                                                    <path
                                                        d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                                    <path
                                                        d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
                                                </svg>
                                                Upload
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="'d-flex">
                                    <form onSubmit={clientFormSubmit} className="admin-form-container">
                                        <h3 className="form-heading">Account Information</h3>
                                        <div className="d-flex desktop-user-form">
                                            <div>
                                                <div className="form-group">
                                                    <label htmlFor="name">Name*</label>
                                                    <input type="text" className="form-control" name="name"
                                                        value={selectedClient ? selectedClient.name : ''}
                                                        onChange={(event) => handleClientChange(event, 'name')}
                                                        placeholder="Type name"
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="email">Email*</label>
                                                    <input type="email" className="form-control" name="email"
                                                        value={selectedClient ? selectedClient.email : ''}
                                                        onChange={(event) => handleClientChange(event, 'email')}
                                                        placeholder="Type email"
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="companyUTR">Company UTR*</label>
                                                    <input type="text" className="form-control" name="companyUTR"
                                                        value={selectedClient && selectedClient.companyUTR ? selectedClient.companyUTR : ''}
                                                        onChange={(event) => handleClientChange(event, 'companyUTR')}
                                                        placeholder="Type company UTR"
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <div className="form-group date-input">
                                                        <label htmlFor="foundedDate">Founded Date*</label>
                                                        <DatePicker id="foundedDate" required
                                                            placeholderText='Founded Date'
                                                            selected={selectedClient && selectedClient.foundedDate ? new Date(selectedClient.foundedDate) : new Date()}
                                                            onChange={(event => handleClientChange(event, "foundedDate"))} />
                                                        <span className="input-group-text">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                                fill="currentColor" className="bi bi-calendar"
                                                                viewBox="0 0 16 16">
                                                                <path
                                                                    d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                                            </svg>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="authCode">Auth Code*</label>
                                                    <input type="text" className="form-control" name="authCode"
                                                        value={selectedClient ? selectedClient.authCode : ''}
                                                        onChange={(event) => handleClientChange(event, 'authCode')}
                                                        placeholder="Type auth code"
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="addressLineOne">Address Line 1*</label>
                                                    <input type="text" className="form-control" name="addressLineOne"
                                                        value={selectedClient ? selectedClient.addressLineOne : ''}
                                                        onChange={(event) => handleClientChange(event, 'addressLineOne')}
                                                        placeholder="Type address line 1"
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="city">City / Town*</label>
                                                    <input type="text" className="form-control" name="city"
                                                        value={selectedClient ? selectedClient.city : ''}
                                                        onChange={(event) => handleClientChange(event, 'city')}
                                                        placeholder="Type city / town"
                                                        required />
                                                </div>
                                                {selectedClient && selectedClient.hasOwnProperty('users') && selectedClient.users.length > 0 &&
                                                    <div className="form-group">
                                                        <label htmlFor="primaryUser">Primary User</label>
                                                        <Select
                                                            className="basic-single btn w-100 select user-select"
                                                            id="primaryUser" options={selectedClient.users}
                                                            onChange={(event) => handleClientChange(event, 'primaryUser')}
                                                            defaultValue={selectedClient.primaryUser}
                                                            getOptionValue={option => option['email']}
                                                            getOptionLabel={option => option['email']} />
                                                    </div>
                                                }
                                            </div>
                                            <div>
                                                <div className="form-group">
                                                    <div className="form-group date-input">
                                                        <label htmlFor="financialDate">Accounting Period*</label>
                                                        <DatePicker id="financialDate" required
                                                            placeholderText='Accounting Period'
                                                            selected={selectedClient && selectedClient.financialDate ? new Date(selectedClient.financialDate) : new Date()}
                                                            onChange={(event => handleClientChange(event, "financialDate"))} />
                                                        <span className="input-group-text">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                                fill="currentColor" className="bi bi-calendar"
                                                                viewBox="0 0 16 16">
                                                                <path
                                                                    d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                                            </svg>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="companyNumber">Company Number*</label>
                                                    <input type="text" className="form-control" name="companyNumber"
                                                        value={selectedClient && selectedClient.companyNumber ? selectedClient.companyNumber : ''}
                                                        onChange={(event) => handleClientChange(event, 'companyNumber')}
                                                        placeholder="Type company number"
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="businessType">Type of Business*</label>
                                                    <input type="text" className="form-control" name="businessType"
                                                        value={selectedClient && selectedClient.businessType ? selectedClient.businessType : ''}
                                                        onChange={(event) => handleClientChange(event, 'businessType')}
                                                        placeholder="Type business type"
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <div className="form-group date-input">
                                                        <label htmlFor="deadlineDate">Deadline Date*</label>
                                                        <DatePicker id="deadlineDate" required
                                                            placeholderText='Deadline Date'
                                                            selected={selectedClient && selectedClient.deadlineDate ? new Date(selectedClient.deadlineDate) : new Date()}
                                                            onChange={(event => handleClientChange(event, "deadlineDate"))} />
                                                        <span className="input-group-text">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                                fill="currentColor" className="bi bi-calendar"
                                                                viewBox="0 0 16 16">
                                                                <path
                                                                    d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                                            </svg>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="vatNumber">VAT Number*</label>
                                                    <input type="text" className="form-control" name="vatNumber"
                                                        value={selectedClient ? selectedClient.vatNumber : ''}
                                                        onChange={(event) => handleClientChange(event, 'vatNumber')}
                                                        placeholder="Type VAT number"
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="addressLineTwo">Address Line 2</label>
                                                    <input type="text" className="form-control" name="addressLineTwo"
                                                        value={selectedClient ? selectedClient.addressLineTwo : ''}
                                                        onChange={(event) => handleClientChange(event, 'addressLineTwo')}
                                                        placeholder="Type address line 2" />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="postcode">Postcode*</label>
                                                    <input type="text" className="form-control" name="postcode"
                                                        value={selectedClient ? selectedClient.postcode : ''}
                                                        onChange={(event) => handleClientChange(event, 'postcode')}
                                                        placeholder="Type postcode"
                                                        required />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mobile-user-form">
                                            <div className="form-group">
                                                <label htmlFor="name">Name*</label>
                                                <input type="text" className="form-control" name="name"
                                                    value={selectedClient ? selectedClient.name : ''}
                                                    onChange={(event) => handleClientChange(event, 'name')}
                                                    placeholder="Type name"
                                                    required />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="email">Email*</label>
                                                <input type="email" className="form-control" name="email"
                                                    value={selectedClient ? selectedClient.email : ''}
                                                    onChange={(event) => handleClientChange(event, 'email')}
                                                    placeholder="Type email"
                                                    required />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="companyNumber">Company Number*</label>
                                                <input type="text" className="form-control" name="companyNumber"
                                                    value={selectedClient && selectedClient.companyNumber ? selectedClient.companyNumber : ''}
                                                    onChange={(event) => handleClientChange(event, 'companyNumber')}
                                                    placeholder="Type company number"
                                                    required />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="companyUTR">Company UTR*</label>
                                                <input type="text" className="form-control" name="companyUTR"
                                                    value={selectedClient && selectedClient.companyUTR ? selectedClient.companyUTR : ''}
                                                    onChange={(event) => handleClientChange(event, 'companyUTR')}
                                                    placeholder="Type company UTR"
                                                    required />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="businessType">Type of Business*</label>
                                                <input type="text" className="form-control" name="businessType"
                                                    value={selectedClient && selectedClient.businessType ? selectedClient.businessType : ''}
                                                    onChange={(event) => handleClientChange(event, 'businessType')}
                                                    placeholder="Type business type"
                                                    required />
                                            </div>
                                            <div className="form-group">
                                                <div className="form-group date-input">
                                                    <label htmlFor="foundedDate">Founded Date*</label>
                                                    <DatePicker id="foundedDate" required
                                                        placeholderText='Founded Date'
                                                        selected={selectedClient && selectedClient.foundedDate ? new Date(selectedClient.foundedDate) : new Date()}
                                                        onChange={(event => handleClientChange(event, "foundedDate"))} />
                                                    <span className="input-group-text">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                            fill="currentColor" className="bi bi-calendar"
                                                            viewBox="0 0 16 16">
                                                            <path
                                                                d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                                        </svg>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="form-group date-input">
                                                    <label htmlFor="financialDate">Accounting Period*</label>
                                                    <DatePicker id="financialDate" required
                                                        placeholderText='Accounting Period'
                                                        selected={selectedClient && selectedClient.financialDate ? new Date(selectedClient.financialDate) : new Date()}
                                                        onChange={(event => handleClientChange(event, "financialDate"))} />
                                                    <span className="input-group-text">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                            fill="currentColor" className="bi bi-calendar"
                                                            viewBox="0 0 16 16">
                                                            <path
                                                                d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                                        </svg>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <div className="form-group date-input">
                                                    <label htmlFor="deadlineDate">Deadline Date*</label>
                                                    <DatePicker id="deadlineDate" required
                                                        placeholderText='Deadline Date'
                                                        selected={selectedClient && selectedClient.deadlineDate ? new Date(selectedClient.deadlineDate) : new Date()}
                                                        onChange={(event => handleClientChange(event, "deadlineDate"))} />
                                                    <span className="input-group-text">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                            fill="currentColor" className="bi bi-calendar"
                                                            viewBox="0 0 16 16">
                                                            <path
                                                                d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                                        </svg>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="authCode">Auth Code*</label>
                                                <input type="text" className="form-control" name="authCode"
                                                    value={selectedClient ? selectedClient.authCode : ''}
                                                    onChange={(event) => handleClientChange(event, 'authCode')}
                                                    placeholder="Type auth code"
                                                    required />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="vatNumber">VAT Number*</label>
                                                <input type="text" className="form-control" name="vatNumber"
                                                    value={selectedClient ? selectedClient.vatNumber : ''}
                                                    onChange={(event) => handleClientChange(event, 'vatNumber')}
                                                    placeholder="Type VAT number"
                                                    required />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="addressLineOne">Address Line 1*</label>
                                                <input type="text" className="form-control" name="addressLineOne"
                                                    value={selectedClient ? selectedClient.addressLineOne : ''}
                                                    onChange={(event) => handleClientChange(event, 'addressLineOne')}
                                                    placeholder="Type address line 1"
                                                    required />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="addressLineTwo">Address Line 2</label>
                                                <input type="text" className="form-control" name="addressLineTwo"
                                                    value={selectedClient ? selectedClient.addressLineTwo : ''}
                                                    onChange={(event) => handleClientChange(event, 'addressLineTwo')}
                                                    placeholder="Type address line 2" />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="city">City / Town*</label>
                                                <input type="text" className="form-control" name="city"
                                                    value={selectedClient ? selectedClient.city : ''}
                                                    onChange={(event) => handleClientChange(event, 'city')}
                                                    placeholder="Type city / town"
                                                    required />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="postcode">Postcode*</label>
                                                <input type="text" className="form-control" name="postcode"
                                                    value={selectedClient ? selectedClient.postcode : ''}
                                                    onChange={(event) => handleClientChange(event, 'postcode')}
                                                    placeholder="Type postcode"
                                                    required />
                                            </div>
                                            {selectedClient && selectedClient.hasOwnProperty('users') && selectedClient.users.length > 0 &&
                                                <div className="form-group">
                                                    <label htmlFor="primaryUser">Primary User</label>
                                                    <Select
                                                        className="basic-single btn w-100 select user-select"
                                                        id="primaryUser" options={selectedClient.users}
                                                        onChange={(event) => handleClientChange(event, 'primaryUser')}
                                                        defaultValue={selectedClient.primaryUser}
                                                        getOptionValue={option => option['email']}
                                                        getOptionLabel={option => option['email']} />
                                                </div>
                                            }
                                        </div>
                                        {success.success &&
                                            <div className="alert alert-success" role="alert">
                                                {success.message}
                                            </div>}
                                        {error.error &&
                                            <div className="alert login-alert alert-danger" role="alert">
                                                {error.errorMessage}
                                            </div>}
                                        <div className="d-flex admin-form-button-container">
                                            <div className="invite-link-container">
                                            </div>
                                            <div className="admin-form-submit-button-container">
                                                <button type="submit" className='black-button' disabled={loading}>
                                                    {loading ?
                                                        <span className="spinner-grow spinner-grow-sm ml-1" role="status"
                                                            aria-hidden="true" />
                                                        : null
                                                    }
                                                    Save
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        }
                        {(selectedUser || addUser) &&
                            <div className="admin-detail-container">
                                <div className="d-flex admin-image-container">
                                    <div>
                                        {selectedUser && selectedUser.imageUrl ?
                                            <img src={selectedUser.imageUrl} alt={selectedUser.firstName}
                                                className='user-image' />
                                            : <img src={avatar} alt="Avatar" className='user-image' />
                                        }
                                    </div>
                                    <div className="d-flex">
                                        <div className="admin-name">
                                            {selectedUser ? (selectedUser.firstName ? selectedUser.firstName : '') + ' ' + (selectedUser.lastName ? selectedUser.lastName : '') : null}
                                            <p>
                                                PNG or JPG no bigger than 1000px wide and tall.
                                            </p>
                                        </div>
                                        <div>
                                            <button className='borderless-button' data-bs-toggle="modal"
                                                data-bs-target="#profileImageModal"
                                                disabled={!(selectedUser && !selectedUser.__isNew__)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="currentColor"
                                                    className="bi bi-upload" viewBox="0 0 16 16">
                                                    <path
                                                        d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
                                                    <path
                                                        d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
                                                </svg>
                                                Upload
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="'d-flex">
                                    <form onSubmit={formSubmit} className="admin-form-container">
                                        <h3 className="form-heading">User Information</h3>
                                        <div className="d-flex desktop-user-form">
                                            <div>
                                                <div className="form-group">
                                                    <label htmlFor="email">Email*</label>
                                                    {addUser ?
                                                        <CreatableSelect
                                                            className="basic-single btn w-100 select user-select"
                                                            id="email"
                                                            options={users}
                                                            onChange={(option) => handleChange(option, 'email')}
                                                            getOptionValue={(option) => option.email}
                                                            getOptionLabel={(option) => option.email}
                                                            getNewOptionData={(inputValue, label) => ({
                                                                email: label,
                                                                __isNew__: true
                                                            })}
                                                        />
                                                        : <input type="email" className="form-control" name="email"
                                                            disabled={selectedUser && selectedUser.hasOwnProperty('lastUpdated')}
                                                            value={selectedUser ? selectedUser.email : ''}
                                                            onChange={(event) => handleChange(event, 'email')}
                                                            placeholder="Type email"
                                                            required />
                                                    }
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="lastName">Last Name*</label>
                                                    <input type="text" className="form-control" name="lastName"
                                                        value={selectedUser && selectedUser.lastName ? selectedUser.lastName : ''}
                                                        onChange={(event) => handleChange(event, 'lastName')}
                                                        placeholder="Type last name"
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="addressLineTwo">Address Line Two</label>
                                                    <input type="text" className="form-control" name="addressLineTwo"
                                                        value={selectedUser && selectedUser.addressLineTwo ? selectedUser.addressLineTwo : ''}
                                                        onChange={(event) => handleChange(event, 'addressLineTwo')}
                                                        placeholder="Type address line two" />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="postcode">Postcode*</label>
                                                    <input type="text" className="form-control" name="postcode"
                                                        value={selectedUser && selectedUser.postcode ? selectedUser.postcode : ''}
                                                        onChange={(event) => handleChange(event, 'postcode')}
                                                        placeholder="Type postcode"
                                                        required />
                                                </div>
                                            </div>
                                            <div>
                                                <div className="form-group">
                                                    <label htmlFor="firstName">First Name*</label>
                                                    <input type="text" className="form-control" name="firstName"
                                                        value={selectedUser && selectedUser.firstName ? selectedUser.firstName : ''}
                                                        onChange={(event) => handleChange(event, 'firstName')}
                                                        placeholder="Type first name"
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="addressLineOne">Address Line One*</label>
                                                    <input type="text" className="form-control" name="addressLineOne"
                                                        value={selectedUser && selectedUser.addressLineOne ? selectedUser.addressLineOne : ''}
                                                        onChange={(event) => handleChange(event, 'addressLineOne')}
                                                        placeholder="Type address line one"
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="city">City / Town*</label>
                                                    <input type="text" className="form-control" name="city"
                                                        value={selectedUser && selectedUser.city ? selectedUser.city : ''}
                                                        onChange={(event) => handleChange(event, 'city')}
                                                        placeholder="Type city / town"
                                                        required />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="phone">Phone*</label>
                                                    <input type="text" className="form-control" name="phone"
                                                        value={selectedUser && selectedUser.phone ? selectedUser.phone : ''}
                                                        onChange={(event) => handleChange(event, 'phone')}
                                                        placeholder="Type phone"
                                                        required />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="mobile-user-form">
                                            <div className="form-group">
                                                <label htmlFor="email">Email*</label>
                                                {addUser ?
                                                    <CreatableSelect
                                                        className="basic-single btn w-100 select user-select"
                                                        id="email"
                                                        options={users}
                                                        value={selectedUser?.email ? users.find(user => user.email === selectedUser.email) || { email: selectedUser.email } : null}
                                                        onChange={(option) => handleChange(option, 'email')}
                                                        getOptionValue={(option) => option.email}
                                                        getOptionLabel={(option) => option.email}
                                                        getNewOptionData={(inputValue, label) => ({
                                                            email: label,
                                                            __isNew__: true
                                                        })}
                                                    />
                                                    : <input type="email" className="form-control" name="email"
                                                        disabled={selectedUser && selectedUser.hasOwnProperty('lastUpdated')}
                                                        value={selectedUser ? selectedUser.email : ''}
                                                        onChange={(event) => handleChange(event, 'email')}
                                                        placeholder="Type email"
                                                        required />
                                                }
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="firstName">First Name*</label>
                                                <input type="text" className="form-control" name="firstName"
                                                    value={selectedUser && selectedUser.firstName ? selectedUser.firstName : ''}
                                                    onChange={(event) => handleChange(event, 'firstName')}
                                                    placeholder="Type first name"
                                                    required />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="lastName">Last Name*</label>
                                                <input type="text" className="form-control" name="lastName"
                                                    value={selectedUser && selectedUser.lastName ? selectedUser.lastName : ''}
                                                    onChange={(event) => handleChange(event, 'lastName')}
                                                    placeholder="Type last name"
                                                    required />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="addressLineOne">Address Line One*</label>
                                                <input type="text" className="form-control" name="addressLineOne"
                                                    value={selectedUser && selectedUser.addressLineOne ? selectedUser.addressLineOne : ''}
                                                    onChange={(event) => handleChange(event, 'addressLineOne')}
                                                    placeholder="Type address line one"
                                                    required />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="addressLineTwo">Address Line Two</label>
                                                <input type="text" className="form-control" name="addressLineTwo"
                                                    value={selectedUser && selectedUser.addressLineTwo ? selectedUser.addressLineTwo : ''}
                                                    onChange={(event) => handleChange(event, 'addressLineTwo')}
                                                    placeholder="Type address line two" />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="city">City / Town*</label>
                                                <input type="text" className="form-control" name="city"
                                                    value={selectedUser && selectedUser.city ? selectedUser.city : ''}
                                                    onChange={(event) => handleChange(event, 'city')}
                                                    placeholder="Type city / town"
                                                    required />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="postcode">Postcode*</label>
                                                <input type="text" className="form-control" name="postcode"
                                                    value={selectedUser && selectedUser.postcode ? selectedUser.postcode : ''}
                                                    onChange={(event) => handleChange(event, 'postcode')}
                                                    placeholder="Type postcode"
                                                    required />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="phone">Phone*</label>
                                                <input type="text" className="form-control" name="phone"
                                                    value={selectedUser && selectedUser.phone ? selectedUser.phone : ''}
                                                    onChange={(event) => handleChange(event, 'phone')}
                                                    placeholder="Type phone"
                                                    required />
                                            </div>
                                        </div>
                                        {success.success &&
                                            <div className="alert alert-success" role="alert">
                                                {success.message}
                                            </div>}
                                        {error.error &&
                                            <div className="alert login-alert alert-danger" role="alert">
                                                {error.errorMessage}
                                            </div>}

                                        {!isMobile ? (
                                            <div className="d-flex admin-form-button-container">
                                                <div className="invite-link-container">
                                                    {selectedUser &&
                                                        selectedUser.hasOwnProperty('lastUpdated') &&
                                                        selectedUser.email !== user.email &&
                                                        clientUsers.some(user => user.email === selectedUser.email) &&
                                                        Array.isArray(selectedUser.userClientInvitations) ? (
                                                        (() => {
                                                            const hasMatchingInvite = selectedUser.userClientInvitations.some(
                                                                (invite) => invite?.clientId === selectedClient.id
                                                            );

                                                            return hasMatchingInvite ? (
                                                                <>
                                                                    <button type="button" className="blue-button" style={{ backgroundColor: "#3DA80A", border: "none" }} disabled >
                                                                        Sent
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="blue-button"
                                                                        style={{
                                                                            backgroundColor: "transparent",
                                                                            color: "#0082FF",
                                                                            border: "none",
                                                                            marginLeft: "5%",
                                                                        }}
                                                                        onClick={sendInvitation}
                                                                        disabled={sendLoading}
                                                                    >
                                                                        {sendLoading ? (
                                                                            <span
                                                                                className="spinner-grow spinner-grow-sm ml-1"
                                                                                role="status"
                                                                                aria-hidden="true"
                                                                            />
                                                                        ) : null}
                                                                        Send Again
                                                                    </button>
                                                                </> 
                                                            ) : (
                                                                <button type="button" className="blue-button" onClick={sendInvitation} disabled={sendLoading}>
                                                                    {sendLoading ? (
                                                                        <span className="spinner-grow spinner-grow-sm ml-1" role="status" aria-hidden="true"/>
                                                                    ) : null}
                                                                    Invite Link
                                                                </button>
                                                            );
                                                        })()
                                                    ) : null}
                                                </div>

                                                <div className="admin-form-submit-button-container">
                                                    {selectedUser && selectedUser.hasOwnProperty('lastUpdated') && selectedUser.email !== user.email && clientUsers.some(user => {
                                                        return user.email === selectedUser.email;
                                                    }) &&
                                                        renderRemoveButton(clientUsers)
                                                    }
                                                    {selectedClient && selectedClient.hasOwnProperty('id') &&
                                                        <button type="submit" className='black-button' disabled={loading}>
                                                            {loading ?
                                                                <span className="spinner-grow spinner-grow-sm ml-1" role="status"
                                                                    aria-hidden="true" />
                                                                : null
                                                            }
                                                            Save
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="admin-form-button-container">
                                                <>
                                                    {selectedUser &&
                                                        selectedUser.hasOwnProperty('lastUpdated') &&
                                                        selectedUser.email !== user.email &&
                                                        clientUsers.some(user => user.email === selectedUser.email) &&
                                                        Array.isArray(selectedUser.userClientInvitations) ? (
                                                        (() => {
                                                            const hasMatchingInvite = selectedUser.userClientInvitations.some(
                                                                (invite) => invite?.clientId === selectedClient.id
                                                            );

                                                            return hasMatchingInvite ? (
                                                                <div className="invite-link-container"  >
                                                                    <button
                                                                        type="button"
                                                                        className="blue-button"
                                                                        style={{ backgroundColor: "#3DA80A", border: "none" }}
                                                                        disabled
                                                                    >
                                                                        Sent
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="blue-button"
                                                                        style={{
                                                                            backgroundColor: "transparent",
                                                                            color: "#0082FF",
                                                                            border: "none",
                                                                            marginLeft: "5%",
                                                                        }}
                                                                        onClick={sendInvitation}
                                                                        disabled={sendLoading}
                                                                    >
                                                                        {sendLoading ? (
                                                                            <span
                                                                                className="spinner-grow spinner-grow-sm ml-1"
                                                                                role="status"
                                                                                aria-hidden="true"
                                                                            />
                                                                        ) : null}
                                                                        Send Again
                                                                    </button>
                                                            </div>
                                                            ) : (
                                                                <button
                                                                    type="button"
                                                                    className="blue-button"
                                                                    onClick={sendInvitation}
                                                                    disabled={sendLoading}
                                                                >
                                                                    {sendLoading ? (
                                                                        <span
                                                                            className="spinner-grow spinner-grow-sm ml-1"
                                                                            role="status"
                                                                            aria-hidden="true"
                                                                        />
                                                                    ) : null}
                                                                    Invite Link
                                                                </button>
                                                            );
                                                        })()
                                                    ) : null}
                                                </>

                                                <div className="d-flex mt-3">
                                                    {selectedUser && selectedUser.hasOwnProperty('lastUpdated') && selectedUser.email !== user.email && clientUsers.some(user => {
                                                        return user.email === selectedUser.email;
                                                    }) &&
                                                        renderRemoveButton(clientUsers)
                                                    }
                                                    {selectedClient && selectedClient.hasOwnProperty('id') &&
                                                        <button type="submit" className='black-button ml-2' disabled={loading}>
                                                            {loading ?
                                                                <span className="spinner-grow spinner-grow-sm ml-1" role="status"
                                                                    aria-hidden="true" />
                                                                : null
                                                            }
                                                            Save
                                                        </button>
                                                    }
                                                </div>
                                            </div>
                                        )}  
                                    </form>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="modal fade" id="deleteUserModal" tabIndex="-1"
                        aria-labelledby="deleteUserModalLabel"
                        aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h1 className="modal-title fs-5 modelfile-title" id="deleteUserModalLabel">Remove User</h1>
                                    {/* <button type="button" className="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"/> */}
                                    <button type="button" className="close-btn" data-bs-dismiss="modal" aria-label="Close">
                                        <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="vuesax/bold/close-circle">
                                                <g id="close-circle">
                                                    <path id="Vector" d="M13.9997 3.18311C7.57134 3.18311 2.33301 8.42144 2.33301 14.8498C2.33301 21.2781 7.57134 26.5164 13.9997 26.5164C20.428 26.5164 25.6663 21.2781 25.6663 14.8498C25.6663 8.42144 20.428 3.18311 13.9997 3.18311ZM17.9197 17.5331C18.258 17.8714 18.258 18.4314 17.9197 18.7698C17.7447 18.9448 17.523 19.0264 17.3013 19.0264C17.0797 19.0264 16.858 18.9448 16.683 18.7698L13.9997 16.0864L11.3163 18.7698C11.1413 18.9448 10.9197 19.0264 10.698 19.0264C10.4763 19.0264 10.2547 18.9448 10.0797 18.7698C9.74134 18.4314 9.74134 17.8714 10.0797 17.5331L12.763 14.8498L10.0797 12.1664C9.74134 11.8281 9.74134 11.2681 10.0797 10.9298C10.418 10.5914 10.978 10.5914 11.3163 10.9298L13.9997 13.6131L16.683 10.9298C17.0213 10.5914 17.5813 10.5914 17.9197 10.9298C18.258 11.2681 18.258 11.8281 17.9197 12.1664L15.2363 14.8498L17.9197 17.5331Z" fill="#B2B9C2" />
                                                </g>
                                            </g>
                                        </svg>
                                    </button>
                                </div>
                                {selectedUser && selectedUser.hasOwnProperty('lastUpdated') &&
                                    <div className="modal-body">
                                        <p>Are you sure you want to remove
                                            user {selectedUser.email} from {selectedClient.name}?</p>
                                        <div className="admin-form-submit-button-container modal-button-container">
                                            <button className='red-button' onClick={() => removeUser()}
                                                data-bs-dismiss="modal">
                                                Remove
                                            </button>
                                            <button className='black-button' data-bs-dismiss="modal">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="modal fade" id="profileImageModal" tabIndex="-1"
                        aria-labelledby="profileImageModalLabel"
                        aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h1 className="modal-title fs-5 modelfile-title" id="profileImageModalLabel">Upload New Profile
                                        Image</h1>
                                    {/* <button type="button" className="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"/> */}
                                    <button type="button" className="close-btn" data-bs-dismiss="modal" aria-label="Close">
                                        <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="vuesax/bold/close-circle">
                                                <g id="close-circle">
                                                    <path id="Vector" d="M13.9997 3.18311C7.57134 3.18311 2.33301 8.42144 2.33301 14.8498C2.33301 21.2781 7.57134 26.5164 13.9997 26.5164C20.428 26.5164 25.6663 21.2781 25.6663 14.8498C25.6663 8.42144 20.428 3.18311 13.9997 3.18311ZM17.9197 17.5331C18.258 17.8714 18.258 18.4314 17.9197 18.7698C17.7447 18.9448 17.523 19.0264 17.3013 19.0264C17.0797 19.0264 16.858 18.9448 16.683 18.7698L13.9997 16.0864L11.3163 18.7698C11.1413 18.9448 10.9197 19.0264 10.698 19.0264C10.4763 19.0264 10.2547 18.9448 10.0797 18.7698C9.74134 18.4314 9.74134 17.8714 10.0797 17.5331L12.763 14.8498L10.0797 12.1664C9.74134 11.8281 9.74134 11.2681 10.0797 10.9298C10.418 10.5914 10.978 10.5914 11.3163 10.9298L13.9997 13.6131L16.683 10.9298C17.0213 10.5914 17.5813 10.5914 17.9197 10.9298C18.258 11.2681 18.258 11.8281 17.9197 12.1664L15.2363 14.8498L17.9197 17.5331Z" fill="#B2B9C2" />
                                                </g>
                                            </g>
                                        </svg>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <form onSubmit={uploadProfileImage}>
                                        <div className="custom-file">
                                            {profileImage ?
                                                <img src={URL.createObjectURL(profileImage)} />
                                                : null
                                            }
                                            <input type="file" className="custom-file-input" accept="image/*" required
                                                id="image" ref={uploadProfileImageInput}
                                                onChange={() => setProfileImage(uploadProfileImageInput.current.files[0])} />
                                            <label className="custom-file-label"
                                                htmlFor="image">
                                                <div className="image-uploader-label">
                                                    Click to upload / Drag and Drop image
                                                </div>
                                            </label>
                                        </div>
                                        <div className="admin-form-submit-button-container modal-button-container">
                                            <button className='blue-button' type="submit">
                                                Upload
                                            </button>
                                            <button type="button" className='black-button' data-bs-dismiss="modal">
                                                Cancel
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal fade" id="clientImageModal" tabIndex="-1"
                        aria-labelledby="clientImageModalLabel"
                        aria-hidden="true">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h1 className="modal-title fs-5 modelfile-title" id="clientImageModalLabel">Upload New Client
                                        Image</h1>
                                    {/* <button type="button" className="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"/> */}
                                    <button type="button" className="close-btn" data-bs-dismiss="modal" aria-label="Close">
                                        <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="vuesax/bold/close-circle">
                                                <g id="close-circle">
                                                    <path id="Vector" d="M13.9997 3.18311C7.57134 3.18311 2.33301 8.42144 2.33301 14.8498C2.33301 21.2781 7.57134 26.5164 13.9997 26.5164C20.428 26.5164 25.6663 21.2781 25.6663 14.8498C25.6663 8.42144 20.428 3.18311 13.9997 3.18311ZM17.9197 17.5331C18.258 17.8714 18.258 18.4314 17.9197 18.7698C17.7447 18.9448 17.523 19.0264 17.3013 19.0264C17.0797 19.0264 16.858 18.9448 16.683 18.7698L13.9997 16.0864L11.3163 18.7698C11.1413 18.9448 10.9197 19.0264 10.698 19.0264C10.4763 19.0264 10.2547 18.9448 10.0797 18.7698C9.74134 18.4314 9.74134 17.8714 10.0797 17.5331L12.763 14.8498L10.0797 12.1664C9.74134 11.8281 9.74134 11.2681 10.0797 10.9298C10.418 10.5914 10.978 10.5914 11.3163 10.9298L13.9997 13.6131L16.683 10.9298C17.0213 10.5914 17.5813 10.5914 17.9197 10.9298C18.258 11.2681 18.258 11.8281 17.9197 12.1664L15.2363 14.8498L17.9197 17.5331Z" fill="#B2B9C2" />
                                                </g>
                                            </g>
                                        </svg>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <form onSubmit={uploadClientImage}>
                                        <div className="custom-file">
                                            {clientProfileImage ?
                                                <img src={URL.createObjectURL(clientProfileImage)} />
                                                : null
                                            }
                                            <input type="file" className="custom-file-input" accept="image/*" required
                                                id="clientImage" ref={uploadClientProfileImageInput}
                                                onChange={() => setClientProfileImage(uploadClientProfileImageInput.current.files[0])} />
                                            <label className="custom-file-label"
                                                htmlFor="clientImage">
                                                <div className="image-uploader-label">
                                                    Click to upload / Drag and Drop image
                                                </div>
                                            </label>
                                        </div>
                                        <div className="admin-form-submit-button-container modal-button-container">
                                            <button className='blue-button' type="submit">
                                                {loading ?
                                                    <span className="spinner-grow spinner-grow-sm ml-1" role="status"
                                                        aria-hidden="true" />
                                                    : null
                                                }
                                                Upload
                                            </button>
                                            <button type="button" className='black-button' data-bs-dismiss="modal">
                                                Cancel
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    } else {
        return null;
    }
}

export default ManageClient;
